import { CheckCircle2Icon } from "lucide-react";
import React from "react";

export default function Step13() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 ">
          <CheckCircle2Icon className="w-8 h-8 text-green-500" />
        </div>
        <div className="">
          <h1>
            <b>PRONTO!</b> Agora basta aguardar a análise dos seus documentos.
            Você será avisado dentro do app da XM e também por e-mail.
          </h1>
        </div>
      </div>
    </div>
  );
}
